import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const ANALYTICS_URL = `${API_URL}/analytics`



const getStats = (companyId:string,filter:string) => {
    return axios
      .get(`${ANALYTICS_URL}/${companyId}/${filter}`)
      .then((d: any) => d.data)
  }


export {getStats}
